import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { linkTheme } from '../Hyperlink/styles'
import styles from './styles'

const ButtonLink = ({ className, theme, label, ...props }) => (
  <button
    type="button"
    className={cx(styles.button, linkTheme(theme), props.disabled && styles.disabled, className)}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}>
    {label}
  </button>
)

ButtonLink.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

ButtonLink.defaultProps = {
  type: 'button',
  theme: 'primary',
}

export default ButtonLink
